import React, { useState } from "react";
import styles from "../styles/TaskNotesEditor.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPen, faSave, faPlus } from "@fortawesome/free-solid-svg-icons";
import { createNote, getNotes, updateNote, deleteNote } from "../api/notes";

interface TaskNote {
  id: number;
  content: string;
  createdById: number;
  createdAt: string;
}

interface Props {
  projectId: number;
  taskId: number;
  notes: TaskNote[];
  onNotesChanged: (notes: TaskNote[]) => void;
}

export default function TaskNotesEditor({ projectId, taskId, notes, onNotesChanged }: Props) {
  const [newNote, setNewNote] = useState<string>("");
  const [editingNoteId, setEditingNoteId] = useState<number | null>(null);
  const [editedContent, setEditedContent] = useState<Record<number, string>>({});
  const currentUserId = Number(localStorage.getItem("userId") ?? "0");

  const handleStartEdit = (noteId: number, original: string) => {
    setEditingNoteId(noteId);
    setEditedContent((prev) => ({ ...prev, [noteId]: original }));
  };

  const handleSave = async (noteId: number) => {
    const trimmed = editedContent[noteId]?.trim();
    if (trimmed) {
      try {
        const updated = await updateNote(projectId, taskId, noteId, { content: trimmed, isDone: false });
        const newNotes = notes.map((n) => (n.id === noteId ? updated : n));
        onNotesChanged(newNotes);
        setEditingNoteId(null);
        alert("نوت با موفقیت ویرایش شد");
      } catch (err: any) {
        alert(err.message || "خطا در ویرایش نوت");
      }
    }
  };


  const handleDelete = async (noteId: number) => {
    // گرفتن تأیید از کاربر
    const confirmed = window.confirm("آیا مطمئن هستید که می‌خواهید این نوت را حذف کنید؟");
    if (!confirmed) return; // اگر کاربر لغو کرد، هیچ کاری انجام نشود

    try {
      await deleteNote(projectId, taskId, noteId);
      const newNotes = notes.filter((n) => n.id !== noteId);
      onNotesChanged(newNotes);
      alert("نوت با موفقیت حذف شد");
    } catch (err: any) {
      alert(err.message || "خطا در حذف نوت");
    }
  };


  const handleAdd = async () => {
    const trimmed = newNote.trim();
    if (!trimmed) return;

    try {
      const added = await createNote(projectId, taskId, trimmed); // await حتماً باشه
      onNotesChanged([...notes, added]);
      setNewNote("");
    } catch (err: any) {
      alert(err.message || "خطا در ایجاد نوت");
    }
  };

  return (
    <div className={styles.container}>
      <h4 className={styles.header}>Notes</h4>

      <div>
        {(notes ?? []).map((note) => {
          const isEditing = editingNoteId === note.id;
          return (
            <div key={note.id} className={styles.noteItem}>
              {isEditing ? (
                <textarea
                  value={editedContent[note.id] ?? ""}
                  onChange={(e) => setEditedContent((prev) => ({ ...prev, [note.id]: e.target.value }))}
                  rows={2}
                  className={styles.noteTextarea}
                />
              ) : (
                <div className={styles.noteText}>{note.content}</div>
              )}
              <div className={styles.noteActions}>
                {isEditing ? (
                  <button className={styles.iconButton} onClick={() => handleSave(note.id)} title="Save">
                    <FontAwesomeIcon icon={faSave} />
                  </button>
                ) : (
                  <button className={styles.iconButton} onClick={() => handleStartEdit(note.id, note.content)} title="Edit">
                    <FontAwesomeIcon icon={faPen} />
                  </button>
                )}
                <button
                  className={`${styles.iconButton} ${styles.deleteButton}`}
                  onClick={() => handleDelete(note.id)}
                  title="Delete"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>

              </div>
              {/*<div className={styles.noteMeta}>
                  {note.createdAt ? new Date(note.createdAt).toLocaleString() : ""}
                </div>*/}
            </div>

          );
        })}
      </div>

      <div className={styles.newNote}>
        <textarea
          placeholder="Add new note..."
          value={newNote}
          onChange={(e) => setNewNote(e.target.value)}
          rows={2}
          className={styles.newNoteTextarea}
        />
        <div className={styles.noteActions}>
          <button className={styles.iconButton} onClick={handleAdd} title="Add">
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>
      </div>
    </div>
  );
}
